import { useVersion } from "../Context/VersionContext";

const VersionDisplay: React.FC = () => {
    const { version } = useVersion();


    return (
        <div className="version-display">{version}</div>
    );
};

export default VersionDisplay;
